import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { CATEGORY_REPORT_ID } from '../category/categoryReportId';

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.CATEGORY.field,
    FIELDS.AUDIENCE_INDEX.field,
    FIELDS.BASELINE_INDEX.field,
    FIELDS.COMPARE.field,
].map(field => generateColumnId(CATEGORY_REPORT_ID, field));

export { defaultColumns };
